/*
 * 以前在rootLayout中设置标题
 * 但是由于存在延迟，导致 pathname 和 title 不匹配
 * 注意：这里不能直接使用window.location，拿到的为全路径，子应用路由中的path不包含基础路径
 * */

import { getMenuData } from '@ant-design/pro-layout'
import { getMatchMenu } from '@umijs/route-utils'

import { getStore } from '@/utils/dva'
import { captureException } from '@/utils/track'
import { isTtDaHuoApp } from '@/utils/singleApp'

// 根据pathname从路由信息中获取标题
export const getTitleByPathname = pathname => {
    const store = getStore()
    const { title } = store?.getState()?.settings || {}

    const { menuData } = getMenuData(PROJECT_CONFIG.routes) || []
    const menu = getMatchMenu(pathname || '/', menuData).pop()

    const { title: routerTitle, channelTitle, supplierTitle } = menu || {}

    if (isTtDaHuoApp) {
        return routerTitle || ''
    }

    let fullTitle = routerTitle ? `${routerTitle} - ${title}` : title

    if (PROJECT_CONFIG.terminalName === 'TOWER') {
        if (MASTER_IS_CHANNEL) {
            fullTitle = channelTitle ? `${channelTitle} - ${title}` : fullTitle
        } else {
            fullTitle = supplierTitle ? `${supplierTitle} - ${title}` : fullTitle
        }
    }

    return fullTitle
}

// 根据pathname设置标题
export const setTitleByPathname = pathname => {
    try {
        const title = getTitleByPathname(pathname)

        if (title) {
            document.title = title
        }
    } catch (e) {
        console.error('catchError', e)
        captureException(e, {
            anchor: 'setTitleByPathname'
        })
    }
}
